export enum SupportedMiniApps {
  TICKETON = 'ticketon',
  ARBUZ = 'arbuz',
  TRAVEL = 'aviata',
  ESIM = 'esim',
  INSURANCE = 'external-insurance',
}
